import { render } from "./VUEFrameComponenteGraficoSpostamenti.vue?vue&type=template&id=4180cbcb&scoped=true"
import script from "./VUEFrameComponenteGraficoSpostamenti.vue?vue&type=script&lang=js"
export * from "./VUEFrameComponenteGraficoSpostamenti.vue?vue&type=script&lang=js"

import "./VUEFrameComponenteGraficoSpostamenti.vue?vue&type=style&index=0&id=4180cbcb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4180cbcb"]])

export default __exports__